module.exports = __webpack_public_path__ + "img/mainImg.03f8ec57.png";